import { Reducer } from 'redux';
import { CriaAgendamentoState, CriaAgendamentoTypes } from './types';

const INITIAL_STATE: CriaAgendamentoState = {
  data: [],
  error: false,
  loading: false,
};

const reducer: Reducer<CriaAgendamentoState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CriaAgendamentoTypes.LOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case CriaAgendamentoTypes.LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        data: action.payload.data,
      };
    case CriaAgendamentoTypes.LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        data: [],
      };
    case CriaAgendamentoTypes.CLEAN_MOVIENTRADA:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default reducer;
